export const GITLAB_VIEWABLE_EXTENSIONS = new Set([
  "c",
  "cc",
  "cfg",
  "conf",
  "cpp",
  "css",
  "csv",
  "dockerfile",
  "env",
  "gitignore",
  "go",
  "h",
  "hpp",
  "html",
  "ini",
  "java",
  "js",
  "json",
  "jsx",
  "log",
  "md",
  "py",
  "rb",
  "rs",
  "scss",
  "sh",
  "sql",
  "svg",
  "toml",
  "ts",
  "tsx",
  "txt",
  "xml",
  "yaml",
  "yml",
]);

export const GITLAB_VIEWABLE_FILENAMES = new Set([
  "dockerfile",
  "makefile",
  "readme",
  "readme.md",
  "license",
  "version",
]);

export const GITLAB_FILE_VIEWER_MAX_BYTES = 512 * 1024;

function getLowercaseFileName(filePath) {
  const parts = filePath.split("/");
  return (parts[parts.length - 1] || "").toLowerCase();
}

function formatPolicySize(sizeBytes) {
  if (typeof sizeBytes !== "number" || Number.isNaN(sizeBytes)) return "—";
  if (sizeBytes < 1024 * 1024) {
    return `${Math.ceil(sizeBytes / 1024).toLocaleString()} KB`;
  }
  return `${(sizeBytes / 1024 / 1024).toFixed(1)} MB`;
}

export function isGitLabFileExtensionViewable(filePath) {
  const fileName = getLowercaseFileName(filePath);

  if (GITLAB_VIEWABLE_FILENAMES.has(fileName)) {
    return true;
  }

  const ext = fileName.includes(".") ? fileName.split(".").pop() : fileName;
  return GITLAB_VIEWABLE_EXTENSIONS.has(ext);
}

export function getGitLabFilePreviewPolicy(filePath, sizeBytes) {
  if (
    typeof sizeBytes === "number" &&
    sizeBytes > GITLAB_FILE_VIEWER_MAX_BYTES
  ) {
    return {
      previewAllowed: false,
      previewDenialReason: `Large File size: ${formatPolicySize(sizeBytes)}.`,
    };
  }

  if (!isGitLabFileExtensionViewable(filePath)) {
    const fileName = getLowercaseFileName(filePath);
    const ext = fileName.includes(".") ? `.${fileName.split(".").pop()}` : "";

    return {
      previewAllowed: true,
      previewDenialReason:
        `Unrecognized file type: '${ext}'. ` +
        "This file may not render contents properly.",
    };
  }

  return {
    previewAllowed: true,
    previewDenialReason: null,
  };
}
